module.exports = __webpack_public_path__ + "static/media/error.d9337c23.png";